import Box from "@mui/material/Box";

import { formatAwsDateString, formatCurrency } from "@covertree/utils";

import { Coverage } from "@graphql/api";

import PropertiesGrid from "@covertree/ui/content/PropertiesGrid";
import { mapCoverageStatus } from "@utils";

interface Props {
  coverage: Coverage;
}

export default function TllCoverageItemContent({ coverage }: Props) {
  return (
    <Box>
      <PropertiesGrid
        properties={[
          {
            label: "BRL Policy ID",
            value: coverage.policyId,
          },
          {
            label: "Unit Status",
            value: mapCoverageStatus(coverage.isActive),
            color: "secondary.main",
          },
          {
            label: "Monthly Unit Cost",
            value: formatCurrency(coverage.annualCost / 12),
          },
        ]}
      />
      <PropertiesGrid
        properties={[
          {
            label: "Unit Coverage Issue Date",
            value: coverage.policyIssuedDate
              ? formatAwsDateString(coverage.policyIssuedDate)
              : "N/A",
          },
          {
            label: "Unit Coverage Effective Date",
            value: formatAwsDateString(coverage.policyEffectiveDate),
          },
          {
            label: "Unit Coverage End Date",
            value: coverage.policyEndDate
              ? formatAwsDateString(coverage.policyEndDate)
              : "N/A",
          },
          ...(coverage.policyEndDate
            ? [
                {
                  label: "Unit Coverage End Reason",
                  value: coverage.policyEndReason ?? "N/A",
                },
              ]
            : []),
          ...(coverage.policyCancellationEffectiveDate &&
          coverage.policyCancellationReason
            ? [
                {
                  label: "Coverage Cancellation Date",
                  value: formatAwsDateString(
                    coverage.policyCancellationEffectiveDate
                  ),
                },
                {
                  label: "Coverage Cancellation Reason",
                  value: coverage.policyCancellationReason ?? "N/A",
                },
              ]
            : []),
        ]}
      />
      <PropertiesGrid
        properties={[
          {
            label: "Blanket Rental Resident Liability Limit",
            value: formatCurrency(
              coverage.coverageDetails.blanketRentalResidentLiabilityLimit
            ),
          },
          {
            label: "Premises Liability Limit",
            value: coverage.coverageDetails.premisesLiabilityLimit
              ? formatCurrency(coverage.coverageDetails.premisesLiabilityLimit)
              : "N/A",
          },
          {
            label: "Animal Liability Limit",
            value: coverage.coverageDetails.animalLiabilityLimit
              ? formatCurrency(coverage.coverageDetails.animalLiabilityLimit)
              : "N/A",
          },
          {
            label: "Medical Payments to Others",
            value: coverage.coverageDetails.medicalPaymentsLimit
              ? formatCurrency(coverage.coverageDetails.medicalPaymentsLimit)
              : "N/A",
          },
        ]}
      />
    </Box>
  );
}
